import React, { Component } from 'react'
import Select from 'react-select';
import { components } from 'react-select'
import { Modal, Form, Col, Button, Row } from 'react-bootstrap';
import SelectDropDown from '../selectdropdown/SelectDropDown';
import gql from "graphql-tag";
import { graphql, withApollo } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from 'lodash.flowright';
import MultiSelect from "react-multi-select-component";
import { withRouter } from "react-router-dom";
import {
    getAuthorizedClassIds,
    getAuthorizedSectionIds,
    getAuthorizedSubjectIds,
    filterByAuthorizedIds
} from "../../utils/authHelper";

const ADD_RESTRICTIONS = gql`
  mutation($params: EmployeeRestrictions) {
    addEmployeeRestrictions(params: $params)
  }`

const GET_EMPLOYEE_ROLES = gql`
  query($institute_id: Int) {
    getEmployeeRoles(institute_id: $institute_id) {
      id
      role_name
    }
  }
`;

// Class options follow the selected branches: union the class_ids across those
// branches' sections, then keep only the getExamClasses whose id matches so we can
// show the class name rather than the raw id.
const getClassesForBranches = (selectedBranchIds, getBranches, getExamClasses) => {
    const wanted = (selectedBranchIds || []).map((id) => String(id));
    const classIds = new Set();

    (getBranches || []).forEach((branch) => {
        if (!wanted.includes(String(branch.id))) return;
        (branch.sections || []).forEach((section) => {
            if (section.class_id != null) classIds.add(String(section.class_id));
        });
    });

    // Narrowed to the classes the logged-in user is assigned (class_ids cookie), so a
    // restricted user can never delegate a class they don't hold themselves. An empty
    // assignment leaves every class of the selected branches available.
    return filterByAuthorizedIds(getExamClasses, getAuthorizedClassIds(), "id")
        .filter((cls) => classIds.has(String(cls.id)))
        .map((cls) => ({ value: cls.id, label: cls.class }));
};

// Section options follow BOTH the selected branches and the selected classes:
// keep only sections that belong to a chosen branch AND whose class_id is one of
// the chosen classes. So the list stays empty until a branch and a class are
// picked. Dedup by section id in case one surfaces under more than one branch.
const getSectionsForSelection = (selectedBranchIds, selectedClassIds, getBranches) => {
    const wantedBranches = (selectedBranchIds || []).map((id) => String(id));
    const wantedClasses = (selectedClassIds || []).map((id) => String(id));
    if (wantedBranches.length === 0 || wantedClasses.length === 0) return [];

    const options = [];
    const seen = new Set();
    // Narrowed to the sections the logged-in user is assigned (section_ids cookie);
    // an empty assignment leaves every section of the selection available.
    const allowedSections = getAuthorizedSectionIds();

    (getBranches || []).forEach((branch) => {
        if (!wantedBranches.includes(String(branch.id))) return;
        filterByAuthorizedIds(branch.sections, allowedSections, "id").forEach((section) => {
            if (section.id == null || seen.has(String(section.id))) return;
            if (!wantedClasses.includes(String(section.class_id))) return;
            seen.add(String(section.id));
            options.push({ value: section.id, label: section.section_name });
        });
    });

    return options;
};

class EmployeeModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Username: "",
            password: "",
            email: "",
            contact_no: "",
            defaultvalue: 0,
            branchesValue: [],
            qbsearchBranches: [],
            branchOptions: [],
            loginUsername: "",
            usernameError: "",
            passwordError: "",
            emailError: "",
            contact_noError: "",
            branchError: "",
            classError: "",
            loginUsernameError: "",

            roles: [],
            selectedRole: "",
            roleError: "",

            subjectsValue: [],
            qbsearchSubjects: [],
            subjectOptions: [],

            classesValue: [],
            qbsearchClasses: [],
            classesOptions: [],

            sectionsValue: [],
            qbsearchSections: [],
            sectionsOptions: [],
            sectionError: "",

            modulesValue: [],
            qbsearchModules: [],
            moduleOptions: [],
            finalModulesArrayPass: [],
            selectedModulesError: "",

            dataClear: 0,

            submitError: "",
            loadingSpinner: 0,
            currentStep: 1,
            showPassword: false,
            profileImage: "",
            uploadingImage: false,
            selectedImageBase64: "",
            selectedImageName: "",
            selectedImageFile: null,
        };
    }

    componentDidUpdate() {
        if (this.props.show === true && this.state.dataClear == 0) {
            // refresh roles every time the modal opens — roles created after the
            // page first mounted (or fetched while the API was down) won't appear otherwise
            this.getRoles();
            this.setState({
                dataClear: 1,
                Username: "", usernameError: "",
                loginUsername: "", loginUsernameError: "",
                password: "", passwordError: "",
                email: "", emailError: "",
                contact_no: "", contact_noError: "",
                branchesValue: [], qbsearchBranches: [], branchError: "",
                classesValue: [], qbsearchClasses: [], classError: "",
                sectionsValue: [], qbsearchSections: [], sectionsOptions: [], sectionError: "",
                modulesValue: [], qbsearchModules: [], finalModulesArrayPass: [], selectedModulesError: "",
                selectedRole: "", roleError: "",
                subjectsValue: [], qbsearchSubjects: [], selectedsubjectsError: "",
                submitError: "", loadingSpinner: 0, currentStep: 1,
                profileImage: "", uploadingImage: false,
                selectedImageBase64: "", selectedImageName: "", selectedImageFile: null,
            })
        }
        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 })
        }
    };

    componentDidMount() {

        let subjectsArray = [];
        let branchesArray = [];

        this.props.getBranches && this.props.getBranches.map((item) => {
            branchesArray.push({ value: item.id, label: item.branch_name })
        })

        // Narrowed to the subjects the logged-in user is assigned (subject_ids cookie);
        // an empty assignment leaves the full subject list available.
        filterByAuthorizedIds(
            this.props.globals.offlineExamSubjects,
            getAuthorizedSubjectIds(),
            "id"
        ).map((item) => {
            const newObj = {
                value: item.id,
                label: item.subject
            }
            subjectsArray.push(newObj)
        })

        // Module list for the access picker — from college_modules (module_name is
        // the key stored in employee.module_access and read by the sidebar).
        let modulesArray = [];
        this.props.getCollegeModules && this.props.getCollegeModules.map((item) => {
            modulesArray.push({ value: item.id, label: item.module_name })
        })

        // classesOptions is empty until a branch is picked — it's derived from the
        // selected branches' sections in handleMultipleSelectInputChange("branches").
        this.setState({ subjectOptions: subjectsArray, classesOptions: [], sectionsOptions: [], branchOptions: branchesArray, moduleOptions: modulesArray })

        this.getRoles();
    };

    getRoles = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_EMPLOYEE_ROLES,
                variables: { institute_id: parseInt(Cookies.get("institutionid")) },
                fetchPolicy: "network-only",
            });
            this.setState({ roles: (result.data && result.data.getEmployeeRoles) || [] });
        } catch {
            this.setState({ roles: [] });
        }
    };

    // show class & subjects only when the chosen role is a teacher
    getSelectedRoleName = () => {
        const role = this.state.roles.find((r) => String(r.id) === String(this.state.selectedRole));
        return role ? (role.role_name || "") : "";
    };

    isTeacherRole = () => this.getSelectedRoleName().trim().toLowerCase().includes("teacher");

    handleInputChange = e => {
        const name = e.target.name;
        const value = e.target.value;

        if (this.state.submitError) {
            this.setState({ submitError: "" });
        }

        var pattern = new RegExp(
            /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
        );

        if (name == "user_name") {
            this.setState({ Username: value, usernameError: "" })
        }
        if (name == "login_user_name") {
            this.setState({ loginUsername: value, loginUsernameError: "" })
        }
        if (name == "password") {
            this.setState({ password: value, passwordError: "" })
        }
        if (name == "email") {
            this.setState({ email: value })

            if (value != "" && !pattern.test(value)) {
                this.setState({ emailError: "Please enter valid email" })
            } else {
                this.setState({ emailError: "" })
            }
        }
        if (name == "contact_no") {
            const digits = value.replace(/\D/g, "").slice(0, 10)
            this.setState({ contact_no: digits, contact_noError: "" })
            if (digits.length > 0 && digits.length < 10) {
                this.setState({ contact_noError: "Mobile number must be 10 digits" })
            } else {
                this.setState({ contact_noError: "" })
            }
        }
        if (name == "role") {
            // switching role: clear class/section/subject picks since they only apply to teachers
            this.setState({ selectedRole: value, roleError: "", classesValue: [], qbsearchClasses: [], classError: "", sectionsValue: [], qbsearchSections: [], sectionsOptions: [], sectionError: "", subjectsValue: [], qbsearchSubjects: [], selectedsubjectsError: "" })
        }
    };

    handleMultipleSelectInputChange = (e, name) => {
        if (this.state.submitError) {
            this.setState({ submitError: "" });
        }
        if (name == "branches") {
            let qbsearchtopic = Array();
            let qbsearchtopicvalue = Array();

            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const qbtopicval = e[i];
                    qbsearchtopicvalue.push({ label: qbtopicval.label, value: qbtopicval.value });
                    qbsearchtopic.push(qbtopicval.value);
                }
            }

            // Re-derive class options for the new branch selection, then drop any
            // previously-picked classes that no longer belong to the chosen branches.
            const classesOptions = getClassesForBranches(qbsearchtopic, this.props.getBranches, this.props.getExamClasses);
            const validClassIds = new Set(classesOptions.map((c) => String(c.value)));
            const classesValue = (this.state.classesValue || []).filter((c) => validClassIds.has(String(c.value)));
            const qbsearchClasses = (this.state.qbsearchClasses || []).filter((id) => validClassIds.has(String(id)));

            // Sections depend on branch AND class: re-derive from the new branches
            // and the still-valid classes, then drop any picked sections that fall
            // outside the new option set.
            const sectionsOptions = getSectionsForSelection(qbsearchtopic, qbsearchClasses, this.props.getBranches);
            const validSectionIds = new Set(sectionsOptions.map((s) => String(s.value)));
            const sectionsValue = (this.state.sectionsValue || []).filter((s) => validSectionIds.has(String(s.value)));
            const qbsearchSections = (this.state.qbsearchSections || []).filter((id) => validSectionIds.has(String(id)));

            this.setState({
                branchesValue: qbsearchtopicvalue,
                qbsearchBranches: qbsearchtopic,
                branchError: "",
                classesOptions,
                classesValue,
                qbsearchClasses,
                sectionsOptions,
                sectionsValue,
                qbsearchSections,
            });
        }

        if (name == "subjects") {
            let qbsearchtopic = Array();
            let qbsearchtopicvalue = Array();

            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const qbtopicval = e[i];
                    const newObj = {
                        label: qbtopicval.label,
                        value: qbtopicval.value,
                        enabled: false,
                    }
                    qbsearchtopicvalue.push(newObj);
                    qbsearchtopic.push(qbtopicval.value);
                }
                this.setState({
                    subjectsValue: qbsearchtopicvalue,
                    qbsearchSubjects: qbsearchtopic,
                });
            }
        }

        if (name == "classes") {
            let qbsearchtopic = Array();
            let qbsearchtopicvalue = Array();

            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const qbtopicval = e[i];
                    const newObj = {
                        label: qbtopicval.label,
                        value: qbtopicval.value,
                    }
                    qbsearchtopicvalue.push(newObj);
                    qbsearchtopic.push(qbtopicval.value);
                }
                // Sections depend on the picked classes — re-derive their options
                // for the new class selection and drop any now-invalid section picks.
                const sectionsOptions = getSectionsForSelection(this.state.qbsearchBranches, qbsearchtopic, this.props.getBranches);
                const validSectionIds = new Set(sectionsOptions.map((s) => String(s.value)));
                const sectionsValue = (this.state.sectionsValue || []).filter((s) => validSectionIds.has(String(s.value)));
                const qbsearchSections = (this.state.qbsearchSections || []).filter((id) => validSectionIds.has(String(id)));

                this.setState({
                    classesValue: qbsearchtopicvalue,
                    qbsearchClasses: qbsearchtopic,
                    classError: "",
                    sectionsOptions,
                    sectionsValue,
                    qbsearchSections,
                });
            }
        }

        if (name == "sections") {
            let qbsearchtopic = Array();
            let qbsearchtopicvalue = Array();

            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const qbtopicval = e[i];
                    qbsearchtopicvalue.push({ label: qbtopicval.label, value: qbtopicval.value });
                    qbsearchtopic.push(qbtopicval.value);
                }
                this.setState({
                    sectionsValue: qbsearchtopicvalue,
                    qbsearchSections: qbsearchtopic,
                    sectionError: "",
                });
            }
        }

        if (name == "modules") {
            let qbsearchtopic = Array();
            let qbsearchtopicvalue = Array();
            let finalModulesArray = Array();

            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const qbtopicval = e[i];
                    qbsearchtopicvalue.push({ label: qbtopicval.label, value: qbtopicval.value });
                    qbsearchtopic.push(qbtopicval.value);
                    // enabled:false == module is GRANTED / visible in the sidebar.
                    finalModulesArray.push({ module_name: qbtopicval.label, enabled: false });
                }
            }
            this.setState({
                modulesValue: qbsearchtopicvalue,
                qbsearchModules: qbsearchtopic,
                finalModulesArrayPass: finalModulesArray,
                selectedModulesError: "",
            });
        }
    };

    handleFormSubmit = async () => {
        if (this.state.qbsearchBranches.length == 0) {
            this.setState({ branchError: "Please select Branch" })
            return ""
        }

        if (this.state.Username == "") {
            this.setState({ usernameError: "Please Enter Employee name", })
            return ""
        }

        if (this.state.loginUsername == "") {
            this.setState({ loginUsernameError: "Please enter user name" })
            return ""
        }

        if (this.state.password == "") {
            this.setState({ passwordError: "Please Enter Password", })
            return ""
        }
        if (this.state.contact_no == "" || this.state.contact_no.length > 10 || this.state.contact_no.length < 10) {
            this.setState({ contact_noError: "Please Enter Contact number", })
            return ""
        }

        if (this.state.selectedRole == "" || this.state.selectedRole == 0) {
            this.setState({ roleError: "Please Select Role" })
            return ""
        }

        if (this.isTeacherRole() && this.state.qbsearchClasses.length == 0) {
            this.setState({ classError: "Please select Class" })
            return ""
        }

        if (this.isTeacherRole() && this.state.subjectsValue.length == 0) {
            this.setState({ selectedsubjectsError: "Please select Subjects" })
            return ""
        }

        this.setState({ loadingSpinner: 1, submitError: "" });

        let profileImageUrl = this.state.profileImage;

        if (this.state.selectedImageBase64) {
            try {
                const response = await this.props.client.mutate({
                    mutation: gql`
                        mutation FileUpload($params: FileUploadInput!) {
                            fileUpload(params: $params) {
                                uuid
                                file_url
                                file_extension_type
                                file_name
                            }
                        }
                    `,
                    variables: {
                        params: {
                            category: "userImages",
                            client_id: parseInt(Cookies.get("institutionid")),
                            file: [
                                {
                                    img: this.state.selectedImageBase64,
                                    filename: this.state.selectedImageName
                                }
                            ]
                        }
                    }
                });

                const fileUploadResult = response?.data?.fileUpload;
                const result = Array.isArray(fileUploadResult) ? fileUploadResult[0] : fileUploadResult;
                if (result && result.file_url) {
                    profileImageUrl = result.file_url;
                } else {
                    this.setState({ loadingSpinner: 0, submitError: "Upload failed." });
                    return;
                }
            } catch (err) {
                console.error("Upload error:", err);
                this.setState({ loadingSpinner: 0, submitError: "Error uploading profile image." });
                return;
            }
        }

        let params = {
            employee_name: this.state.Username,
            username: this.state.loginUsername,
            emp_mobile: this.state.contact_no,
            emp_email: this.state.email,
            password: this.state.password,
            employee_role_id: this.state.selectedRole,
            subject_ids: this.state.qbsearchSubjects.toString(),
            institute_id: parseInt(Cookies.get("institutionid")),
            branch_id: this.state.qbsearchBranches.join(","),
            class_ids: this.state.qbsearchClasses.toString(),
            section_ids: this.state.qbsearchSections.toString(),
            module_access: this.state.finalModulesArrayPass,
            profile_image: profileImageUrl,
        }

        this.addEmployeeRestrictions(params).catch(error => {
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message),
                loadingSpinner: 0,
            });
        });
    };

    handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
        if (!allowedTypes.includes(file.type)) {
            this.setState({ submitError: "Invalid format. Only JPEG and PNG files are allowed." });
            return;
        }

        const reader = new FileReader();
        reader.onload = () => {
            this.setState({
                selectedImageFile: file,
                selectedImageBase64: reader.result,
                selectedImageName: file.name,
                submitError: "",
            });
        };
        reader.readAsDataURL(file);
    };

    handleImageRemove = (e) => {
        if (e) e.preventDefault();
        this.setState({ selectedImageBase64: "", selectedImageName: "", selectedImageFile: null, profileImage: "" });
        if (this.fileInputRef) this.fileInputRef.value = "";
    };

    addEmployeeRestrictions = async params => {
        await this.props.addEmployeeRestrictions({
            variables: {
                params
            },
            update: (store, { data }) => {
                if (data.addEmployeeRestrictions) {
                    this.setState({
                        loadingSpinner: 1,
                        currentStep: 5,
                    });

                    setTimeout(() => {
                        this.SetpageLoad();
                    }, 1500);
                }
            }
        });
    };

    SetpageLoad = () => {
        // Reset the form and close the modal, then refresh just the employees
        // table in place — no full-page reload.
        this.setState({
            currentStep: 1, submitError: "", loadingSpinner: 0, dataClear: 0,
            Username: "", usernameError: "",
            loginUsername: "", loginUsernameError: "",
            password: "", passwordError: "",
            email: "", emailError: "",
            contact_no: "", contact_noError: "",
            branchesValue: [], qbsearchBranches: [], branchError: "",
            selectedRole: "", roleError: "",
            classesValue: [], qbsearchClasses: [], classError: "",
            sectionsValue: [], qbsearchSections: [], sectionsOptions: [], sectionError: "",
            subjectsValue: [], qbsearchSubjects: [], selectedsubjectsError: "",
            modulesValue: [], qbsearchModules: [], finalModulesArrayPass: [], selectedModulesError: "",
            profileImage: "", selectedImageBase64: "", selectedImageName: "", selectedImageFile: null,
        });
        this.props.onHide();
        if (this.props.refetchEmployees) {
            this.props.refetchEmployees();
        }
    };

    render() {

        let subjectSelectAll = true;
        let subjectLabelledBy = "Select";
        let subjectdisablesearch = false;
        if (this.state.subjectOptions.length > 0) {
            subjectSelectAll = true;
            subjectdisablesearch = false;
        }
        else {
            subjectdisablesearch = true;
            subjectSelectAll = false;
            subjectLabelledBy = "Subjects"
        }
        let classSelectAll = true;
        let classLabelledBy = "Select";
        let classdisablesearch = false;
        if (this.state.classesOptions.length > 0) {
            classSelectAll = true;
            classdisablesearch = false;
        }
        else {
            classdisablesearch = true;
            classSelectAll = false;
            classLabelledBy = "Classes"
        }
        let sectionSelectAll = true;
        let sectionLabelledBy = "Select";
        let sectiondisablesearch = false;
        if (this.state.sectionsOptions.length > 0) {
            sectionSelectAll = true;
            sectiondisablesearch = false;
        }
        else {
            sectiondisablesearch = true;
            sectionSelectAll = false;
            sectionLabelledBy = "Sections"
        }

        const FIN = {
            label: { fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 5, display: "block" },
            input: { borderRadius: 9, border: "1.5px solid #e5e7eb", padding: "9px 12px", fontSize: 14, color: "#1f2937", background: "#f9fafb", width: "100%", height: 44 },
            err: { color: "#dc2626", fontSize: 12, marginTop: 3, display: "block" },
            section: { background: "#fff", borderRadius: 12, padding: "20px 20px 8px", marginBottom: 16, boxShadow: "0 1px 4px rgba(0,0,0,0.06)" },
            heading: { fontSize: 13, fontWeight: 700, color: "#0f172a", marginBottom: 14, display: "flex", alignItems: "center", gap: 7 },
            btnPrimary: { display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 6, background: "#7c3aed", color: "#fff", border: "none", borderRadius: 8, padding: "7px 18px", fontSize: 12.5, fontWeight: 600, cursor: "pointer" },
            req: { color: "#dc2626" },
        };

        const roleName = this.getSelectedRoleName();
        const avatarSrc = this.state.selectedImageBase64 || this.state.profileImage;

        return (
            <Modal {...this.props} size="lg" aria-labelledby="add-employee-modal" centered dialogClassName="edu-emp-modal">
                <style>{`
                  .edu-emp-modal .modal-content { border: none !important; border-radius: 16px; overflow: hidden; padding: 0 !important; }
                  .edu-emp-modal .modal-body { padding: 0 !important; overflow: visible; }
                  .edu-emp-modal .modal-dialog { max-width: 760px; }
                  .edu-emp-modal .modal-body .mb-3 { margin-bottom: 0.55rem !important; }
                  .edu-profile-upload-wrapper:hover .edu-profile-upload-overlay { opacity: 1 !important; }
                  .modules-branchdd { position: relative; z-index: 100; }
                  .modules-branchdd .dropdown-content { position: absolute; z-index: 9999 !important; background: #fff; }
                  .modules-dropup { position: relative; z-index: 1; }
                  .modules-dropup:focus-within { z-index: 9999; }
                  .modules-dropup .dropdown-content { top: auto; bottom: 100%; }
                  .modules-dropup .select-item { padding: 8px 10px; margin-bottom: 4px; }
                `}</style>
                <Modal.Body>
                    <div style={{ position: "relative", display: "flex", flexWrap: "wrap", alignItems: "stretch" }}>

                        {/* Close */}
                        <button type="button" onClick={this.props.onHide} aria-label="Close" style={{ position: "absolute", top: 14, right: 14, zIndex: 5, background: "#f1f5f9", border: "1px solid #e2e8f0", color: "#475569", width: 32, height: 32, borderRadius: "50%", cursor: "pointer", fontSize: 15, lineHeight: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <i className="fal fa-times" />
                        </button>

                        {/* LEFT — avatar / summary */}
                        <div style={{ flex: "0 0 240px", maxWidth: 240, width: "100%", background: "linear-gradient(160deg,#213046 0%,#131c2b 100%)", color: "#fff", padding: "34px 24px", display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
                            <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase", color: "#f8c52c", marginBottom: 24 }}>
                                <i className="fal fa-user-plus mr-2" />Add Employee
                            </div>

                            <div
                                className="edu-profile-upload-wrapper"
                                onClick={() => this.fileInputRef.click()}
                                style={{ position: "relative", width: 112, height: 112, borderRadius: "50%", border: "3px solid #f8c52c", overflow: "hidden", cursor: "pointer", background: "rgba(255,255,255,0.08)", display: "flex", alignItems: "center", justifyContent: "center" }}
                            >
                                {avatarSrc ? (
                                    <img src={avatarSrc} alt="Profile" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                ) : (
                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", color: "#fff" }}>
                                        {this.state.uploadingImage ? (
                                            <span className="spinner-border spinner-border-sm" style={{ color: "#f8c52c" }} />
                                        ) : (
                                            <>
                                                <i className="fal fa-camera" style={{ fontSize: 22, color: "#f8c52c" }} />
                                                <span style={{ fontSize: 10, marginTop: 4, fontWeight: 600 }}>Upload</span>
                                            </>
                                        )}
                                    </div>
                                )}
                                <div className="edu-profile-upload-overlay" style={{ position: "absolute", bottom: 0, left: 0, right: 0, background: "rgba(0,0,0,0.45)", color: "#fff", fontSize: 10, textAlign: "center", padding: "3px 0", opacity: 0, transition: "opacity 0.2s" }}>
                                    Change
                                </div>
                            </div>

                            {avatarSrc ? (
                                <button type="button" onClick={this.handleImageRemove} style={{ marginTop: 10, background: "transparent", border: "none", color: "#f8c52c", fontSize: 11, fontWeight: 700, cursor: "pointer" }}>
                                    <i className="fal fa-times-circle mr-1" />Remove photo
                                </button>
                            ) : null}

                            <div style={{ fontSize: 17, fontWeight: 800, marginTop: 16, wordBreak: "break-word", lineHeight: 1.25 }}>
                                {this.state.Username || "New Employee"}
                            </div>
                            {roleName ? (
                                <div style={{ marginTop: 8, fontSize: 12, fontWeight: 700, background: "#f8c52c", color: "#213046", borderRadius: 20, padding: "4px 14px" }}>
                                    {roleName}
                                </div>
                            ) : null}
                            {this.state.selectedImageName ? (
                                <div style={{ marginTop: 16, fontSize: 11, opacity: 0.85, wordBreak: "break-all" }}>
                                    <i className="fal fa-file-image mr-1" />{this.state.selectedImageName}
                                </div>
                            ) : null}

                            <div style={{ marginTop: 22, fontSize: 12, fontWeight: 700, color: "#fff", display: "flex", alignItems: "center", gap: 7, opacity: 0.9 }}>
                                <i className="fal fa-id-badge" style={{ color: "#f8c52c" }} />Employee Details
                            </div>
                            <div style={{ marginTop: 6, width: 40, height: 2, background: "#f8c52c", borderRadius: 2 }} />
                            <p style={{ marginTop: 12, fontSize: 11.5, color: "rgba(255,255,255,0.7)", lineHeight: 1.6, marginBottom: 0 }}>
                                Fill the employee's profile, login, role and module access on the right.
                            </p>

                            <input
                                type="file"
                                ref={ref => this.fileInputRef = ref}
                                style={{ display: "none" }}
                                accept="image/*"
                                onChange={this.handleImageChange}
                            />
                        </div>

                        {/* RIGHT — form */}
                        <div style={{ flex: "1 1 360px", background: "#fff", padding: "30px 30px 10px" }}>
                            <Row>
                                <Col lg={6} md={12} sm={12} className="mb-3">
                                    <label style={FIN.label}>Branch <span style={FIN.req}>*</span></label>
                                    <MultiSelect
                                        className="modules-branchdd"
                                        overrideStrings={{ "allItemsAreSelected": "All Branches are selected.", "selectSomeItems": "Select Branches" }}
                                        disableSearch={this.state.branchOptions.length === 0}
                                        hasSelectAll={this.state.branchOptions.length > 0}
                                        options={this.state.branchOptions}
                                        value={this.state.branchesValue}
                                        onChange={(e) => this.handleMultipleSelectInputChange(e, "branches")}
                                        labelledBy={"Branches"}
                                    />
                                    {this.state.branchError ? <span style={FIN.err}>{this.state.branchError}</span> : null}
                                </Col>

                                <Col lg={6} md={12} sm={12} className="mb-3">
                                    <label style={FIN.label}>Employee Name <span style={FIN.req}>*</span></label>
                                    <input style={FIN.input} type="text" placeholder="Employee Name" name="user_name" maxLength={50} onChange={this.handleInputChange} autoComplete="off" value={this.state.Username} />
                                    {this.state.usernameError ? <span style={FIN.err}>{this.state.usernameError}</span> : null}
                                </Col>

                                <Col lg={6} md={12} sm={12} className="mb-3">
                                    <label style={FIN.label}>Username <span style={FIN.req}>*</span></label>
                                    <input style={FIN.input} type="text" placeholder="User Name" name="login_user_name" maxLength={20} onChange={this.handleInputChange} autoComplete="off" value={this.state.loginUsername} />
                                    {this.state.loginUsernameError ? <span style={FIN.err}>{this.state.loginUsernameError}</span> : null}
                                </Col>

                                <Col lg={6} md={12} sm={12} className="mb-3">
                                    <label style={FIN.label}>Employee Password <span style={FIN.req}>*</span></label>
                                    <div style={{ position: "relative" }}>
                                        <input style={{ ...FIN.input, paddingRight: 36 }} type={this.state.showPassword ? "text" : "password"} placeholder="Password" maxLength={15} onChange={this.handleInputChange} autoComplete="new-password" name="password" value={this.state.password} />
                                        <i
                                            className={this.state.showPassword ? "far fa-eye" : "far fa-eye-slash"}
                                            onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                                            style={{ position: "absolute", right: 12, top: 14, cursor: "pointer", color: "#6b7280" }}
                                        />
                                    </div>
                                    {this.state.passwordError ? <span style={FIN.err}>{this.state.passwordError}</span> : null}
                                </Col>

                                <Col lg={6} md={12} sm={12} className="mb-3">
                                    <label style={FIN.label}>Email</label>
                                    <input style={FIN.input} type="email" placeholder="Email" name="email" maxLength={100} onChange={this.handleInputChange} autoComplete="off" value={this.state.email} />
                                    {this.state.emailError ? <span style={FIN.err}>{this.state.emailError}</span> : null}
                                </Col>

                                <Col lg={6} md={12} sm={12} className="mb-3">
                                    <label style={FIN.label}>Contact No</label>
                                    <input style={FIN.input} type="text" inputMode="numeric" maxLength={10} placeholder="Mobile No" name="contact_no" onChange={this.handleInputChange} autoComplete="off" value={this.state.contact_no} />
                                    {this.state.contact_noError ? <span style={FIN.err}>{this.state.contact_noError}</span> : null}
                                </Col>

                                <Col lg={6} md={12} sm={12} className="mb-3">
                                    <label style={FIN.label}>Role <span style={FIN.req}>*</span></label>
                                    <select style={FIN.input} name="role" onChange={this.handleInputChange} value={this.state.selectedRole}>
                                        <option value="">Select Role</option>
                                        {this.state.roles.map(item => (
                                            <option key={item.id} value={item.id}>{item.role_name}</option>
                                        ))}
                                    </select>
                                    {this.state.roleError ? <span style={FIN.err}>{this.state.roleError}</span> : null}
                                </Col>

                                {this.isTeacherRole() ? (
                                    <Col lg={6} md={12} sm={12} className="mb-3">
                                        <label style={FIN.label}>Select Class <span style={FIN.req}>*</span></label>
                                        <MultiSelect
                                            className="modules-dropup"
                                            overrideStrings={{ "allItemsAreSelected": "All Classes are selected.", "selectSomeItems": classLabelledBy }}
                                            disableSearch={classdisablesearch}
                                            hasSelectAll={classSelectAll}
                                            options={this.state.classesOptions}
                                            value={this.state.classesValue}
                                            onChange={(e) => this.handleMultipleSelectInputChange(e, "classes")}
                                            labelledBy={"Classes"}
                                        />
                                        {this.state.classError ? <span style={FIN.err}>{this.state.classError}</span> : null}
                                    </Col>
                                ) : null}

                                {this.isTeacherRole() ? (
                                    <Col lg={6} md={12} sm={12} className="mb-3">
                                        <label style={FIN.label}>Select Section</label>
                                        <MultiSelect
                                            className="modules-dropup"
                                            overrideStrings={{ "allItemsAreSelected": "All Sections are selected.", "selectSomeItems": sectionLabelledBy }}
                                            disableSearch={sectiondisablesearch}
                                            hasSelectAll={sectionSelectAll}
                                            options={this.state.sectionsOptions}
                                            value={this.state.sectionsValue}
                                            onChange={(e) => this.handleMultipleSelectInputChange(e, "sections")}
                                            labelledBy={"Sections"}
                                        />
                                        {this.state.sectionError ? <span style={FIN.err}>{this.state.sectionError}</span> : null}
                                    </Col>
                                ) : null}

                                {this.isTeacherRole() ? (
                                    <Col lg={6} md={12} sm={12} className="mb-3">
                                        <label style={FIN.label}>Select Subjects</label>
                                        <MultiSelect
                                            className="modules-dropup"
                                            overrideStrings={{ "allItemsAreSelected": "All Subjects are selected.", "selectSomeItems": subjectLabelledBy }}
                                            disableSearch={subjectdisablesearch}
                                            hasSelectAll={subjectSelectAll}
                                            options={this.state.subjectOptions}
                                            value={this.state.subjectsValue}
                                            onChange={(e) => this.handleMultipleSelectInputChange(e, "subjects")}
                                            labelledBy={"Subjects"}
                                        />
                                        {this.state.selectedsubjectsError ? <span style={FIN.err}>{this.state.selectedsubjectsError}</span> : null}
                                    </Col>
                                ) : null}

                            </Row>

                            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", marginTop: 4, paddingTop: 12, borderTop: "1px solid #f1f5f9" }}>
                                {this.state.currentStep == 5 ? (
                                    <p style={{ color: "#059669", fontWeight: 600, marginBottom: 8 }}>Data Saved Successfully</p>
                                ) : this.state.submitError ? (
                                    <p style={{ color: "#dc2626", marginBottom: 8 }}>{this.state.submitError}</p>
                                ) : null}
                                <button type="button" style={FIN.btnPrimary} onClick={this.handleFormSubmit}>
                                    {this.state.loadingSpinner == 1 ? <span className="spinner-border spinner-border-sm" /> : <i className="fas fa-save" />}
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
}

export default compose(
    withApollo,
    graphql(ADD_RESTRICTIONS, {
        name: "addEmployeeRestrictions"
    })
)(EmployeeModal);